module.exports = __webpack_public_path__ + "img/icon-check.48f861e6.svg";